import { getObjectionTitle, getPersonalityLabels, getPractitionerTypes } from "../../services/utils";
import { formatCallFocusDisplay } from "../praxis-play/CustomizerModal";
import type { CallDetailRow } from "./components/CallDetailsPopover";

export function buildCallDetailRows(args: {
  callDetails: any;
  tenantProfile: any;
  sessionGroup?: string;
  callFocusAvailable: boolean;
}): CallDetailRow[] {
  const { callDetails, tenantProfile, sessionGroup, callFocusAvailable } = args;
  if (!callDetails?.id) return [];

  const objections: any[] = tenantProfile?.objections || [];
  const group = sessionGroup;
  const practitionerTypes =
    getPractitionerTypes(tenantProfile?.practitioner_types || {}, group) || [];
  const pt = practitionerTypes.find(
    (t: { key?: string; type?: string }) =>
      t.key === callDetails.practitionerType || t.type === callDetails.practitionerType,
  );
  const hcp = pt?.type || pt?.key || callDetails.practitionerType || "—";

  const personality =
    getPersonalityLabels(callDetails.personalityType as string, tenantProfile, group) || "—";

  const objection =
    getObjectionTitle(callDetails.objectionLevel as string, objections) ||
    callDetails.objectionLevel ||
    "—";

  const topics = (callDetails as { topics?: string[] }).topics;
  const practitionerTag =
    (callDetails as { practitionerTag?: string }).practitionerTag ?? pt?.tag;
  const callFocusText =
    callFocusAvailable && topics?.length
      ? formatCallFocusDisplay(tenantProfile, topics, group, practitionerTag)
      : "";

  const beginRaw = callDetails.beginTime;
  const minutes =
    beginRaw !== undefined && beginRaw !== null && beginRaw !== "" ? Number(beginRaw) : NaN;
  const timeLimit =
    !Number.isNaN(minutes) && minutes > 0 ? `${minutes} minute${minutes === 1 ? "" : "s"}` : "—";

  const rows: CallDetailRow[] = [
    { label: "HCP", value: String(hcp) },
    { label: "PERSONALITY", value: String(personality) },
    { label: "OBJECTION LEVEL", value: String(objection) },
  ];

  if (callFocusText) {
    rows.push({ label: "CALL FOCUS", value: callFocusText });
  }

  rows.push({ label: "TIME LIMIT", value: timeLimit });

  return rows;
}
